var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveSessions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#3D79F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5417 19.5L12.8354 17.7938C12.7285 17.6868 12.6458 17.5629 12.5875 17.4222C12.5292 17.2814 12.5 17.133 12.5 16.9771V14.25C12.5 13.9292 12.6143 13.6544 12.843 13.4258C13.0717 13.1971 13.3462 13.0829 13.6667 13.0833H14.25L13.6667 13.6667V11.3333C13.6667 11.1681 13.7227 11.0294 13.8347 10.9174C13.9467 10.8054 14.0851 10.7496 14.25 10.75C14.4153 10.75 14.5539 10.806 14.6659 10.918C14.7779 11.03 14.8337 11.1684 14.8333 11.3333V13.0833H17.1667V11.3333C17.1667 11.1681 17.2227 11.0294 17.3347 10.9174C17.4467 10.8054 17.5851 10.7496 17.75 10.75C17.9153 10.75 18.0539 10.806 18.1659 10.918C18.2779 11.03 18.3337 11.1684 18.3333 11.3333V13.6667L17.75 13.0833H18.3333C18.6542 13.0833 18.9289 13.1977 19.1576 13.4263C19.3863 13.655 19.5004 13.9296 19.5 14.25V16.9771C19.5 17.1326 19.4708 17.281 19.4125 17.4222C19.3542 17.5633 19.2715 17.6872 19.1646 17.7938L17.4583 19.5V20.6667C17.4583 20.8319 17.4023 20.9706 17.2903 21.0826C17.1783 21.1946 17.0399 21.2504 16.875 21.25H15.125C14.9597 21.25 14.8211 21.194 14.7091 21.082C14.5971 20.97 14.5413 20.8316 14.5417 20.6667V19.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#E0E9FA",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSessions);
export default __webpack_public_path__ + "static/media/active-sessions.3ba52f135992f5e9cfee4cc675536072.svg";
export { ForwardRef as ReactComponent };